export default "__VITE_ASSET__82418593__"